import { lazy } from 'react';
import { Navigate } from 'react-router';
import { ErrorPage } from '@/components/ErrorPage';
import Loadable from '@/components/loadable';

const AdminLayout = Loadable(lazy(() => import('@/pages/admin/layout')));
const UsersPage = Loadable(lazy(() => import('../pages/admin/users-page')));
const AppsPage = Loadable(lazy(() => import('../pages/admin/apps-page')));

const AdminRoutes = {
  path: '/admin',
  element: <AdminLayout />,
  children: [
    {
      element: <ErrorPage />,
    },
    {
      path: '',
      children: [
        { index: true, element: <Navigate to="/admin/users" replace /> },
        { path: 'users', element: <UsersPage /> },
        { path: 'apps', element: <AppsPage /> },
        { path: 'dashboard', element: <Navigate to="/admin/users" replace /> },
      ],
    },
  ],
};

export default AdminRoutes;
